import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  available: { label: "Available", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  rented: { label: "Rented Out", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  under_repair: { label: "Under Repair", cls: "bg-indigo-100 text-indigo-700 border-indigo-200" },
  retired: { label: "Retired", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  active: { label: "Active", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  overdue: { label: "Overdue", cls: "bg-red-100 text-red-700 border-red-200" },
  returned: { label: "Returned", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function StatusBadge({ status, testid }) {
  const cfg = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <Badge data-testid={testid} variant="outline" className={`font-medium ${cfg.cls}`}>
      {cfg.label}
    </Badge>
  );
}
